/**
 * GPS coordinated-turn lean knobs. Tuning any value here: edit →
 * `npm run build` in src/PitBrain.Shared → restart/rebuild the clients.
 */

/**
 * Unit: ms. Half-window over which the GPS heading rate behind the
 * coordinated lean is measured: the chord runs between the fix nearest to
 * t − 300 ms and the fix nearest to t + 300 ms, ties resolving to the fix
 * further OUT (±3 fixes = ±300 ms at 10 Hz; at 25 Hz the 280/320 tie takes
 * ±8 fixes = ±320 ms), and always at least one fix on each side so the
 * chord cannot collapse at low GPS rates. Time-based so a 25 Hz and a
 * 10 Hz receiver smooth the corner-entry flick over the same interval: on
 * the paired 2026-09-06 Gelleråsen fixture the cross-device apex residual
 * is 1.42° here against 2.07° when the window was 3 fixes on each device.
 * Default: 300
 */
export const COORDINATED_LEAN_HEADING_HALF_WINDOW_MS = 300
